/**
 * Sanitizes a string by removing special characters and limiting length
 */
export function sanitizeString(name: string): string {
  return name
    .replace(/[^a-zA-Z0-9\s-_]/g, '')
    .replace(/\s+/g, '_')
    .toLowerCase()
    .slice(0, 100)
}
